import type { StateCreator } from "zustand";

import type { IState } from "../persistedStore";

export interface IShowroomState {
  showroomToken: string;
  setShowroomToken: (tokenValue: string) => void;
  clearShowroomToken: () => void;
}

const createShowroomSlice: StateCreator<IState, [], [], IShowroomState> = (
  set,
  _get,
) => ({
  showroomToken: "",
  setShowroomToken: (tokenValue: string) =>
    set(() => ({ showroomToken: tokenValue })),
  clearShowroomToken: () => set(() => ({ showroomToken: "" })),
});

export default createShowroomSlice;
